import axios from 'axios';

const adminUrl = process.env.VUE_APP_ADMIN_URL;

function headers() {
  const accessToken = JSON.parse(localStorage.getItem('accessToken'));
  return { Authorization: `Bearer ${accessToken}` };
}

// Nota: el backend de /mrr-daily responde con el envelope { data, meta } /
// { error: { code, message } } (no el { status: 'ok' } usado por el resto
// del admin). Este service traduce esa respuesta al contrato { status, data }
// para que el resto del frontend siga el patrón habitual sin excepciones.
export default class MrrDailyService {
  static async getSeries(year, month) {
    try {
      const response = await axios.get(`${adminUrl}/mrr-daily`, {
        params: { year, month },
        headers: headers(),
      });
      return { status: 'ok', data: response.data.data, meta: response.data.meta };
    } catch (err) {
      const message = err.response?.data?.error?.message || 'Error al cargar el MRR diario';
      return { status: 'error', message };
    }
  }

  static async getContractSeries(contrato, year, month) {
    try {
      const response = await axios.get(`${adminUrl}/mrr-daily/contract-series`, {
        params: { contrato, year, month },
        headers: headers(),
      });
      return { status: 'ok', data: response.data.data, meta: response.data.meta };
    } catch (err) {
      const message = err.response?.data?.error?.message || 'Error al cargar la tendencia del contrato';
      return { status: 'error', message };
    }
  }

  static async getContractChanges(date, year, month) {
    try {
      const response = await axios.get(`${adminUrl}/mrr-daily/contract-changes`, {
        params: { date, year, month },
        headers: headers(),
      });
      return { status: 'ok', data: response.data.data, meta: response.data.meta };
    } catch (err) {
      const message = err.response?.data?.error?.message || 'Error al cargar los cambios por contrato';
      return { status: 'error', message };
    }
  }
}
